import shared from './shared';
import authorization from './authorization';

export default {
    shared,
    authorization
};
